import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useCurrentPatientFile } from '../_components/patient-file.provider'
import AddFollowup from './_components/add-followup.component'

export default function AddPatientFollowupPage() {
  const { projectId, patientId } = useParams()
  const { t } = useTranslation()
  const { patient } = useCurrentPatientFile()

  if (!projectId || !patientId) throw new Error(t('common.error.wrong-project-id-or-patient-id'))

  return <AddFollowup patient={patient} />
}
